import configs from "./configs";

const folder = configs.REACT_APP_NAME
  ? configs.REACT_APP_NAME.toLowerCase()
  : "onland";

const scene = () => {
  const appName = folder;
  try {
    return require(`./assets/templates/${appName}/${appName}.mud`);
  } catch (e) {
    return require("./assets/templates/default.mud");
  }
};

export const defaultThumbnail = () => {
  const appName = folder;
  try {
    return require(`./assets/templates/${appName}/thumbnail.jpg`);
  } catch (e) {
    return require("./assets/templates/thumbnail.jpg");
  }
};

function fixBaseAssetsPath(path) {
  // eslint-disable-next-line no-undef
  if (!path.startsWith(__webpack_public_path__)) {
    // eslint-disable-next-line no-useless-escape
    const matches = path.match(/^([^\/]+\/).+$/);

    if (matches.length > 1) {
      // eslint-disable-next-line no-undef
      return __webpack_public_path__ + path.replace(matches[1], "");
    }
  }

  return path;
}

export const defaultScene = () => fixBaseAssetsPath(scene());
